import { FIELDS } from './constants';

const defaultFields = [
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RMAId',
    field: FIELDS.RMAID,
    title: ' RMAId',
    label: 'RMAId',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RMANo',
    field: FIELDS.RMANO,
    title: ' RMANo',
    label: 'RMANo',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyId',
    field: FIELDS.COMPANY_ID,
    title: ' Company Id',
    label: 'CompanyId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Company Name',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorId',
    field: FIELDS.VENDOR_ID,
    title: ' Vendor Id',
    label: 'VendorId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'VendorName',
    field: FIELDS.VENDOR_NAME,
    title: ' Vendor Name',
    label: 'VendorName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorRMAId',
    field: FIELDS.VENDOR_RMAID,
    title: ' Vendor RMAId',
    label: 'VendorRMAId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorRMALineId',
    field: FIELDS.VENDOR_RMALINE_ID,
    title: ' Vendor RMALine Id',
    label: 'VendorRMALineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryId',
    field: FIELDS.INVENTORY_ID,
    title: ' Inventory Id',
    label: 'InventoryId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InvoiceLineId',
    field: FIELDS.INVOICE_LINE_ID,
    title: ' Invoice Line Id',
    label: 'InvoiceLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SOLineId',
    field: FIELDS.SOLINE_ID,
    title: ' SOLine Id',
    label: 'SOLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseOrderId',
    field: FIELDS.PURCHASE_ORDER_ID,
    title: ' Purchase Order Id',
    label: 'PurchaseOrderId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'POLineId',
    field: FIELDS.POLINE_ID,
    title: ' POLine Id',
    label: 'POLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RequirementLineId',
    field: FIELDS.REQUIREMENT_LINE_ID,
    title: ' Requirement Line Id',
    label: 'RequirementLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QuoteLineId',
    field: FIELDS.QUOTE_LINE_ID,
    title: ' Quote Line Id',
    label: 'QuoteLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RMADate',
    field: FIELDS.RMADATE,
    title: ' RMADate',
    label: 'RMADate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RMATermsId',
    field: FIELDS.RMATERMS_ID,
    title: ' RMATerms Id',
    label: 'RMATermsId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RMATermsName',
    field: FIELDS.RMATERMS_NAME,
    title: ' RMATerms Name',
    label: 'RMATermsName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CustomerPO',
    field: FIELDS.CUSTOMER_PO,
    title: ' Customer Purchase Order',
    label: 'Customer Purchase Order',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ContactId',
    field: FIELDS.CONTACT_ID,
    title: ' Contact Id',
    label: 'ContactId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ContactFullName',
    field: FIELDS.CONTACT_FULL_NAME,
    title: ' Contact Full Name',
    label: 'ContactFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesPersonUserId',
    field: FIELDS.SALES_PERSON_USER_ID,
    title: ' Sales Person User Id',
    label: 'SalesPersonUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesPersonUserFullName',
    field: FIELDS.SALES_PERSON_USER_FULL_NAME,
    title: ' Sales Person User Full Name',
    label: 'SalesPersonUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ApprovedByUserFullName',
    field: FIELDS.APPROVED_BY_USER_FULL_NAME,
    title: ' Approved By User Full Name',
    label: 'ApprovedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartId',
    field: FIELDS.PART_ID,
    title: ' Part Id',
    label: 'PartId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: ' Part Number',
    label: 'PartNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: ' NSNNumber',
    label: 'NSNNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: ' Alt Number',
    label: 'AltNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'HarmonizedCode',
    field: FIELDS.HARMONIZED_CODE,
    title: ' Harmonized Code',
    label: 'HarmonizedCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: ' SKU',
    label: 'SKU',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ManufacturerId',
    field: FIELDS.MANUFACTURER_ID,
    title: ' Manufacturer Id',
    label: 'ManufacturerId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'MfgName',
    field: FIELDS.MFG_NAME,
    title: ' Mfg Name',
    label: 'MfgName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryClassId',
    field: FIELDS.INVENTORY_CLASS_ID,
    title: ' Inventory Class Id',
    label: 'InventoryClassId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: ' Class Name',
    label: 'ClassName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryCategoryId',
    field: FIELDS.INVENTORY_CATEGORY_ID,
    title: ' Inventory Category Id',
    label: 'InventoryCategoryId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: ' Category Name',
    label: 'CategoryName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PackageId',
    field: FIELDS.PACKAGE_ID,
    title: ' Package Id',
    label: 'PackageId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: ' Package',
    label: 'Package',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: ' Piece Per Pkg',
    label: 'PiecePerPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UoMId',
    field: FIELDS.UO_MID,
    title: ' Uo MId',
    label: 'UoMId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: ' UOM',
    label: 'UOM',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: ' Lead Free',
    label: 'LeadFree',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: ' Temp Rating',
    label: 'TempRating',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: ' Date Code',
    label: 'DateCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: ' Lot Code',
    label: 'LotCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: ' Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Cost',
    field: FIELDS.COST,
    title: ' Cost',
    label: 'Cost',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TotalCost',
    field: FIELDS.TOTAL_COST,
    title: ' Total Cost',
    label: 'TotalCost',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryOfOriginId',
    field: FIELDS.COUNTRY_OF_ORIGIN_ID,
    title: ' Country Of Origin Id',
    label: 'CountryOfOriginId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionId',
    field: FIELDS.CONDITION_ID,
    title: ' Condition Id',
    label: 'ConditionId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyInvoiced',
    field: FIELDS.QTY_INVOICED,
    title: ' Qty Invoiced',
    label: 'QtyInvoiced',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyReturning',
    field: FIELDS.QTY_RETURNING,
    title: ' Qty Returning',
    label: 'QtyReturning',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QtyReceived',
    field: FIELDS.QTY_RECEIVED,
    title: ' Qty Received',
    label: 'QtyReceived',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RMAReasonId',
    field: FIELDS.RMAREASON_ID,
    title: ' RMAReason Id',
    label: 'RMAReasonId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RMAReasonName',
    field: FIELDS.RMAREASON_NAME,
    title: ' RMAReason Name',
    label: 'RMAReasonName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullName',
    field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
    title: ' Modified By User Full Name',
    label: 'ModifiedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'isService',
    field: FIELDS.IS_SERVICE,
    title: 'Is Service',
    label: 'isService',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
